<div class="restore-details column">
  <mat-card appearance="outlined" class="information-card">
    <div class="header row">
      <div class="title row">
        <h3>Restore summary</h3>
        <button matRipple class="button">
          <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
        </button>
      </div>
    </div>
    <div class="info-row row">
      @for (info of restoreSummary; track $index) {
        <div class="info">
          <div class="label">{{ info.label }}</div>
          @let text = info.text(restoreData);
          <div class="text">{{ text }}</div>
        </div>
      }
    </div>
  </mat-card>

  <mat-card appearance="outlined" class="information-card">
    <div class="header row line">
      <div class="title row">
        <fa-icon [icon]="['fas', 'globe']" size="lg"></fa-icon>
        <h3>{{ websiteData.website.domain }}</h3>
      </div>
      <small
        >Started
        {{ restoreData.startDate ? (restoreData.startDate | date: 'dd.MM.yyyy, hh:mm') : 'N/A' }} →
        {{ restoreData.endDate ? (restoreData.endDate | date: 'dd.MM.yyyy, hh:mm') : 'N/A' }}</small
      >
    </div>

    @if (configRestore$ | async; as config) {
      <div class="panel">
        <div class="expansion-header row">
          <fa-icon [icon]="['fas', 'chevron-down']" size="lg"></fa-icon>
          <b>Restore Config</b>
          <app-status-label [status]="toStatus(config.status)"></app-status-label>
        </div>
        <div class="config-table">
          <app-table
            #table
            [columns]="restoreConfigColumns"
            [dataSource]="config.actions"
            [totalCount]="config.actions.length"
            [showPaginator]="false"
          >
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <app-status-label [status]="toStatus(element.status)"></app-status-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="button"
                    matTooltip="Restore Config"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="showConfig(element)"
                  >
                    <fa-icon [icon]="['fas', 'circle-info']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="button"
                    [matTooltip]="'Restore Log' + (!element.logs.length ? ' (no logs)' : '')"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    [disabled]="!element.logs.length"
                    (click)="showLogs(element)"
                  >
                    <fa-icon [icon]="['fas', 'list-ul']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>
          </app-table>
        </div>
      </div>
    }

    @if (snapshotRestore && snapshotRestore.websiteRestoreTargets.length > 0) {
      <div class="panel column">
        <div class="expansion-header row">
          <fa-icon [icon]="['fas', 'chevron-down']" size="lg"></fa-icon>
          <b>Snapshots Restore: Files, database(s) and mailboxes</b>
          <app-status-label
            [status]="fromWebsiteRestoreStatus(snapshotRestore.status)"
          ></app-status-label>
        </div>
        <div class="snapshots column">
          @if (snapshotFiles?.restoreBackupTarget; as target) {
            <div class="snapshot-data row">
              <div class="column">
                <b>Files</b>
                <span>{{ target.snapshotTarget }}</span>
              </div>
              <app-status-label [status]="fromTaskStatus(snapshotFiles!.status)"></app-status-label>
            </div>
          }

          @if (snapshotDatabases && snapshotDatabases.length > 0) {
            <div class="snapshot-data row">
              <div class="column">
                <b>Databases</b>
                <div class="row">
                  <span
                    >{{ visibleDatabases }}

                    @if (!showAllDatabases && remainingDatabasesCount > 0) {
                      <button mat-button (click)="showAllDatabases = true">
                        +{{ remainingDatabasesCount }} more
                      </button>
                    }
                  </span>
                </div>
              </div>
              <div class="snapshot-status row">
                <span
                  >{{ snapshotDatabases.length }}
                  {{ snapshotDatabases.length === 1 ? 'Database' : 'Databases' }}
                </span>
                <app-status-label
                  [status]="fromTaskStatus(snapshotDatabases![0].status)"
                ></app-status-label>
              </div>
            </div>
          }

          @if (snapshotMailboxes && snapshotMailboxes.length > 0) {
            <div class="snapshot-data row">
              <div class="column">
                <b>Mailboxes</b>
                <div class="row">
                  <span
                    >{{ visibleMailboxes }}

                    @if (!showAllMailboxes && remainingMailboxesCount > 0) {
                      <button mat-button (click)="showAllMailboxes = true">
                        +{{ remainingMailboxesCount }} more
                      </button>
                    }
                  </span>
                </div>
              </div>
              <div class="snapshot-status row">
                <span
                  >{{ snapshotMailboxes.length }}
                  {{ snapshotMailboxes.length === 1 ? 'Mailbox' : 'Mailboxes' }}
                </span>
                <app-status-label
                  [status]="fromTaskStatus(snapshotMailboxes![0].status)"
                ></app-status-label>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </mat-card>
</div>
